'use strict';
/* eslint-disable */
const $ = jQuery.noConflict();
$(function() {

	const stickyBlock = {

		init: function() {
			this.activeClassForStickyCards();
            this.numCounterStickyCards();
			if ($('.sticky-block__card-left-btn').length === 0) {
				$('.sticky-block').addClass('no-btn');
			}
			$(document).ready(function () {
				const isDesktop = window.matchMedia('(hover: hover)').matches;

				if (isDesktop) {
					const videos = document.querySelectorAll('.sticky-video');

					const observer = new IntersectionObserver((entries) => {
						entries.forEach(entry => {
							const video = entry.target;

							if (entry.isIntersecting) {
								video.play().catch(() => {});
							} else {
								video.pause();
							}
						});
					}, { threshold: 0.5 });

					videos.forEach(video => observer.observe(video));

				} else {
					$('.sticky-video').each(function () {
						this.play().catch(() => {});
					});
				}
			});

		},

		activeClassForStickyCards: function() {
			const cards = document.querySelectorAll('.sticky-block__card');
			const topOffset = 150;

			function checkCards() {
				cards.forEach(card => {
					const rect = card.getBoundingClientRect();
					if (rect.top <= topOffset && rect.bottom > topOffset) {
						card.classList.add('is-active');
					} else {
						card.classList.remove('is-active');
					}
				});
			}

			window.addEventListener('scroll', checkCards);
			checkCards();
		},

        numCounterStickyCards: function() {
            $('.sticky-block__card').each(function(index) {
                $(this).find('.sticky-block__card-left-top-num').text(('0' + (index + 1)).slice(-2));
            });
        }

	};

	stickyBlock.init();
});
